/**
 * @generated SignedSource<<bd1ae48b7b20caed77e2b0a79e093f19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CommentThreadAccessType = "EVERYONE" | "INDIVIDUALS";
export type CommentType = "REOPEN" | "RESOLVE" | "TEXT";
export type CommentsPanelQuery$variables = {
  key: string;
};
export type CommentsPanelQuery$data = {
  readonly commentThreads: ReadonlyArray<{
    readonly access: {
      readonly accessType: CommentThreadAccessType;
      readonly addedBy: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
      } | null;
      readonly users: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
      }>;
    } | null;
    readonly comments: ReadonlyArray<{
      readonly createdAt: string | null;
      readonly editedAt: string | null;
      readonly html: string;
      readonly id: string;
      readonly isDeleted: boolean;
      readonly text: string;
      readonly type: CommentType;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isExternal: boolean;
        readonly isGuest: boolean;
      };
    }>;
    readonly fullUrl: string | null;
    readonly id: string;
    readonly key: string;
    readonly resolvedAt: string | null;
  }> | null;
  readonly viewer: {
    readonly user: {
      readonly account: {
        readonly id: string;
      };
      readonly id: string;
    };
  };
};
export type CommentsPanelQuery = {
  response: CommentsPanelQuery$data;
  variables: CommentsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Literal",
    "name": "resolved",
    "value": false
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resolvedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "comments",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "html",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "addedBy",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v9/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "users",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v6/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CommentThread",
        "kind": "LinkedField",
        "name": "commentThreads",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CommentThreadAccess",
            "kind": "LinkedField",
            "name": "access",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CommentThread",
        "kind": "LinkedField",
        "name": "commentThreads",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CommentThreadAccess",
            "kind": "LinkedField",
            "name": "access",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2cef4cd5742c81828528931f977d883d",
    "id": null,
    "metadata": {},
    "name": "CommentsPanelQuery",
    "operationKind": "query",
    "text": "query CommentsPanelQuery(\n  $key: String!\n) {\n  commentThreads(key: $key, resolved: false) {\n    id\n    key\n    resolvedAt\n    fullUrl\n    comments {\n      id\n      createdAt\n      editedAt\n      text\n      html\n      type\n      isDeleted\n      user {\n        id\n        fullName\n        image\n        isGuest\n        isExternal\n      }\n    }\n    access {\n      accessType\n      addedBy {\n        id\n        email\n        fullName\n      }\n      users {\n        id\n        fullName\n        email\n      }\n      id\n    }\n  }\n  viewer {\n    user {\n      id\n      account {\n        __typename\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "01f830693f1e0377db309028920879d9";

export default node;
